<template>
	<transition :css="false">
		<div
			:id="uniqueId"
			ref="gridLayout"
			class="grid-layout"
		>
			<transition name="sidebar-fade">
				<div
					v-show="withSidebar"
					id="left-col"
				>
					<div
						id="left-header"
						class="px-4"
					>
						<slot name="left-header">
							<Title :value="leftTitle" />
						</slot>
					</div>
					<div id="left-content">
						<slot name="left-content"></slot>
					</div>
					<div
						id="left-footer"
						class="px-4"
					>
						<slot name="left-footer"></slot>
					</div>
				</div>
			</transition>
			<div id="right-col">
				<div
					id="right-header"
					class="px-4"
				>
					<slot name="right-header">
						<button
							v-if="showBackButton"
							class="btn btn-rounded"
							@click="Back"
						>
							<i class="fas fa-chevron-left"></i>
						</button>
						<Title :value="rightTitle" />
						<div v-if="showFavoriteRouteCheckbox">
							<FavoriteRoute />
						</div>
					</slot>
				</div>
				<div id="right-content">
					<slot name="right-tool-bar"></slot>
					<slot name="right-content"></slot>
					<slot name="right-info-bar"></slot>
				</div>
				<div
					id="right-footer"
					class="px-4"
				>
					<slot name="right-footer"></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'
	import { useGetUniqueId } from '@/composables'

	export default {
		name: 'GridLayout',
		props: {
			leftTitle: {
				type: String,
				default: 'FILTROS',
			},
			rightTitle: {
				type: String,
				default: '',
			},
			reactiveSidebar: {
				type: Boolean,
				default: true,
			},
			sidebarState: {
				type: Boolean,
				default: true,
			},
			currentRoute: {
				type: String,
				default: '',
			},
			showBackButton: {
				type: Boolean,
				default: true,
			},
			backAction: {
				type: Function,
				default: null,
			},
			showFavoriteRouteCheckbox: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				uniqueId: '',
				withSidebar: false,
			}
		},
		computed: {
			...mapGetters('system', ['showSidebar']),
		},
		watch: {
			showSidebar: {
				handler(show) {
					if (!this.reactiveSidebar) return

					this.SidebarHandler(show)
				},
				immediate: true,
			},
			sidebarState: {
				handler(val) {
					this.SidebarHandler(val)
				},
				immediate: true,
			},
		},
		methods: {
			async SidebarHandler(show) {
				await this.$nextTick()

				const grid = document.querySelector(`#${this.uniqueId}`)
				if (!grid) return

				const left = document.querySelector(
					`#${this.uniqueId} #left-col`
				)
				if (!left) return

				this.withSidebar = show

				if (show) {
					grid.classList.add('with-sidebar')
				} else {
					grid.classList.remove('with-sidebar')
				}
			},
			Back() {
				if (!this.backAction) {
					this.$router.push({ name: 'Home' })
				} else {
					this.backAction()
				}
			},
		},
		beforeMount() {
			this.uniqueId = useGetUniqueId('grid')
		},
	}
</script>

<style lang="scss"></style>
